import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadInvalidBets } from './invalidBetsData'
import type { InvalidBetsQuery } from './invalidBetsTypes'

/** Invalid Bets — live Keycloak → Agent-API `getVARBets` / `searchIBLogs`. */
export function useInvalidBets(query: InvalidBetsQuery) {
  return useQuery({
    queryKey: keys.invalidBets(query),
    queryFn: () => loadInvalidBets(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
